import React, { useEffect } from 'react';
import { Box, Typography, Button, Paper, IconButton } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';

const ApprovalSuccessPage = () => {
  const handleCloseTab = () => {
    // Try to close the window
     window.close();
  };

  useEffect(() => {
    // Set window name so we can identify it later
    window.name = 'EstimateApprovalSuccess';
  }, []);

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      textAlign: 'center',
      padding: 3,
      background: 'linear-gradient(to bottom right, #daf0ff, #e3ebf2, #cbf5dd)'
    }}>
      <Paper 
        elevation={3}
        sx={{
          padding: 4,
          maxWidth: 500,
          width: '100%',
          borderRadius: 2,
          position: 'relative'
        }}
      >
        <IconButton 
          onClick={handleCloseTab}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'text.secondary'
          }}
        >
          <CloseIcon />
        </IconButton>

        <CheckCircleIcon 
          sx={{ 
            fontSize: 80, 
            mb: 3,
            color: '#23A26D'
          }} 
        />
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
          Estimate Approved Successfully
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, fontSize: '1.1rem' }}>
          Thank you! The estimate has been approved and saved.
        </Typography>                        
        <Button
          variant="contained"
          color='main'
          fullWidth
          onClick={handleCloseTab}
          sx={{                
            py: 1.2,
            fontSize: '1.1rem',
            fontWeight: 600
          }}
        >
          Close This Tab
        </Button>
      </Paper>
    </Box>
  );
};

export default ApprovalSuccessPage;